/** Resolve organization_id from iframe URL, storage, or parent shell messages. */
export function readOrganizationIdFromContext() {
  if (typeof window === 'undefined') return null;

  const fromUrl = new URLSearchParams(window.location.search).get('organization_id');
  if (fromUrl) {
    try {
      localStorage.setItem('organization_id', fromUrl);
      localStorage.setItem('organizationId', fromUrl);
      localStorage.setItem('selectedOrganizationId', fromUrl);
    } catch (e) {
      /* private mode / quota */
    }
    return fromUrl;
  }

  return (
    localStorage.getItem('selectedOrganizationId') ||
    localStorage.getItem('organizationId') ||
    localStorage.getItem('organization_id') ||
    localStorage.getItem('selected_organization_id') ||
    null
  );
}

/** Fired when Settings → Organization saves or org profile is loaded from SaaS API. */
export const ORGANIZATION_PROFILE_UPDATED = 'organization-profile-updated';

/** Prevent sync listener → persist → listener recursion (CustomEvent is synchronous). */
let persistOrganizationProfileDepth = 0;

/**
 * Persist org id/name for sidebar/header and notify OrganizationProvider listeners.
 * @param {{ id?: string, name?: string } | null | undefined} org
 */
export function persistOrganizationProfile(org) {
  if (!org?.id || typeof window === 'undefined') return;
  // Nested call from an ORGANIZATION_PROFILE_UPDATED listener — storage already written.
  if (persistOrganizationProfileDepth > 0) return;

  const orgId = String(org.id);
  const orgName = org.name != null && org.name !== '' ? String(org.name) : null;

  try {
    localStorage.setItem('selectedOrganizationId', orgId);
    localStorage.setItem('organizationId', orgId);
    if (orgName) {
      localStorage.setItem('organizationName', orgName);
    }
  } catch {
    /* private mode / quota */
  }

  persistOrganizationProfileDepth += 1;
  try {
    window.dispatchEvent(
      new CustomEvent(ORGANIZATION_PROFILE_UPDATED, {
        detail: {
          organization: {
            ...org,
            id: orgId,
            name: orgName || org.name,
          },
        },
      })
    );
  } finally {
    persistOrganizationProfileDepth -= 1;
  }
}
